// AlgoSetupPopOut.jsx
// Standalone popup window that hosts the AI Stock Scan / Algo Setup table.
// Opens via window.open('/algo-setup-popout', ...) from Grid view's top bar.
// Same component (AlgoSetupTab) and same backend APIs as the in-app version,
// so it auto-refreshes in real time using the same polling logic.

import React, { useEffect } from "react";
import { Toaster } from "sonner";
import AlgoSetupTab from "../components/AlgoSetupTab";

const AlgoSetupPopOut = () => {
  useEffect(() => {
    document.title = "AI Stock Scan — AlphaTradeVission Ticks";
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0e17] text-white">
      <Toaster position="top-right" theme="dark" />
      <div className="h-screen flex flex-col">
        <AlgoSetupTab
          // No onClose here — closing the popup = closing the browser window
          onClose={() => window.close()}
          isFullScreen={true}
          onToggleFullScreen={() => {}}
          highlightedCells={{}}
        />
      </div>
    </div>
  );
};

export default AlgoSetupPopOut;
